export default __webpack_public_path__ + "static/media/icono-cerrar.af8951e6.svg";